import 'whatwg-fetch';

function buildRequest(method, payload, additionalHeaders = {}) {
    const headers = additionalHeaders.headers || {
        'Content-Type': 'application/json'
    };

    const request = {
        method,
        headers,
        credentials: 'same-origin'
    };
    if (payload) {
        request.body = JSON.stringify(payload);
    }
    return request;
}

function apiGet(api, payload, headers) {
    return fetch(api, buildRequest('GET', payload, headers));
}

function apiPost(api, payload, headers) {
    return fetch(api, buildRequest('POST', payload, headers));
}

export {
    apiGet, apiPost
};
